var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PanelHeaderButton',{attrs:{"enabled":_vm.isBrowseModeEnabled},on:{"click":_vm.toggleBrowseMode}},[_vm._v("browse")])
}
var staticRenderFns = []

export { render, staticRenderFns }